import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map-compass",
  "use": "icon-map-compass-usage",
  "viewBox": "0 0 10 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 10 22\" id=\"icon-map-compass\">\n<style type=\"text/css\">\n\t#icon-map-compass .st0{fill:#F55C45;}\n\t#icon-map-compass .st1{fill:#FFFFFF;}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M5,0l5,11H0L5,0z\" />\n\t<path class=\"st1\" d=\"M5,22L0,11h10L5,22z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol